import { render, staticRenderFns } from "./GroupMessage.vue?vue&type=template&id=7c9f10d8&scoped=true"
import script from "./GroupMessage.vue?vue&type=script&lang=js"
export * from "./GroupMessage.vue?vue&type=script&lang=js"
import style0 from "./GroupMessage.vue?vue&type=style&index=0&id=7c9f10d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9f10d8",
  null
  
)

export default component.exports